import 'regenerator-runtime';
import Vue from 'vue';
import { VJSBridgeFront } from './libs/VJSBridgeFront';
import getAegis from './utils/aegis';

import {
  Tabs,
  Tab,
  Divider,
  Cell,
  PasswordInput,
  NumberKeyboard,
  Button,
  Icon,
  Radio,
  RadioGroup,
  Checkbox,
  Toast,
  Form,
  Field,
  PullRefresh,
  Skeleton,
  Popup,
  Overlay,
  Collapse,
  CollapseItem,
  Picker,
  Search,
  Area,
  Uploader,
  List,
  Lazyload,
  Image,
  Loading,
} from 'vant';

// directives
import versionCheck from './directive/version-check';
import supportAccountCheck from './directive/support-account-check';

// Components
import App from './App.vue';
import store from './store';
import router from './router';

// CSS相关
import 'normalize.css/normalize.css'; // CSS reset
import '@/styles/index.scss'; // global css
import '@/icons';
import GlobalPlugin from '@/plugins/global';
import MessagePlugin from '@/plugins/message';

// 工具函数相关
import { isNullish, initProConsole } from '@tencent/v-common-utils';

if (process.env.VUE_APP_BUILD_FOR !== 'production') {
  import('vconsole').then(({ default: VConsole }) => {
    (window as any).vConsole = new VConsole();
  });
}

// async function generatorFunc() {}
// generatorFunc();

// vant 组件应用
Vue.use(Button);
Vue.use(PasswordInput);
Vue.use(Radio);
Vue.use(RadioGroup);
Vue.use(Icon);
Vue.use(Checkbox);
Vue.use(Toast);
Vue.use(Form);
Vue.use(Field);
Vue.use(Cell);
Vue.use(Divider);
Vue.use(Tabs);
Vue.use(Tab);
Vue.use(NumberKeyboard);
Vue.use(PullRefresh);
Vue.use(Skeleton);
Vue.use(Popup);
Vue.use(Overlay);
Vue.use(Collapse);
Vue.use(CollapseItem);
Vue.use(Picker);
Vue.use(Search);
Vue.use(Area);
Vue.use(Uploader);
Vue.use(List);
Vue.use(Lazyload);
Vue.use(Image);
Vue.use(Loading);

Vue.use(GlobalPlugin);
Vue.use(MessagePlugin);

Vue.directive('version-check', versionCheck);
Vue.directive('support-account-check', supportAccountCheck);

Vue.config.productionTip = false;

// aegis 捕获错误
const aegis = getAegis();
Vue.config.errorHandler = function (err) {
  aegis?.error(err);
};

// 处理图片请求错误占位图
window.addEventListener(
  'error',
  (e) => {
    if (isNullish(e)) return;
    const { target } = e as any; // 当前dom节点
    const { tagName } = target;
    // 当前异常是由图片加载异常引起的
    if (!isNullish(tagName) && tagName.toUpperCase() === 'IMG') {
      target.classList.add('error');
    }
  },
  true,
);

// 初始化全局ProConsole
initProConsole('v-creator-center');

// 初始化JSBrideFront
VJSBridgeFront.setup();

export default new Vue({
  el: '#app',
  router,
  store,
  render: (h) => h(App),
});
